/**
 * The Memory Shelf — Tracking Page Enhancer
 * Enhances ParcelPanel /apps/rastrear-encomenda header with TMS branding.
 */
document.addEventListener('DOMContentLoaded', function() {
  var ppContainer = document.getElementById('pp-tracking-page-app');
  if (!ppContainer) return;

  if (document.getElementById('tms-injected-tracking-hero')) return;

  var heroDiv = document.createElement('div');
  heroDiv.id = 'tms-injected-tracking-hero';
  heroDiv.className = 'tms-tracking-hero';
  heroDiv.innerHTML = `
    <div class="tms-tracking-badge">
      <span>✨</span> Acompanhamento em Tempo Real
    </div>
    <h1 class="tms-tracking-title tms-shelf-title">Onde está a tua memória?</h1>
    <p class="tms-tracking-subtitle">Introduz os dados da tua encomenda ou o código de rastreio para acompanhar cada etapa até à entrega em tua casa.</p>
  `;

  var trackingContent = ppContainer.querySelector('.pp_tracking_content') || ppContainer;
  if (trackingContent.firstChild) {
    trackingContent.insertBefore(heroDiv, trackingContent.firstChild);
  } else {
    trackingContent.appendChild(heroDiv);
  }
});
